import React, { Component } from 'react';
import { ArrowRightIcon } from '../../../../../../common/icons';

import './GroupsCard.css';

export default class GroupsCard extends Component {
  render() {
    const { theme, title, description, onClick, selected, disabled } = this.props;
    return (
      <div
        className={`GroupsCard ${!!selected ? 'Selected' : ''} ${!!disabled ? 'Disabled' : ''} ${!selected && theme === 'alternative' ? 'Alternative' : ''}`}
        onClick={!disabled ? onClick : undefined}
      >
        <div>
          <div className="GroupName">{title}</div>
          <div className="GroupDescription">{description}</div>
        </div>
        <div>
          <ArrowRightIcon />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/Groups/GroupsCard/GroupsCard.js